var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "baseAutoHorizonScrollMain",
      staticClass: "baseAutoHorizonScrollMain"
    },
    [
      _c(
        "div",
        {
          ref: "autoScrollContent",
          staticClass: "autoScrollContent",
          class: _vm.scrollClass
        },
        [_vm._v("\n        " + _vm._s(_vm.text) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.ifNeedScroll
        ? _c(
            "div",
            { staticClass: "autoScrollContent", class: _vm.scrollClass },
            [_vm._v("\n        " + _vm._s(_vm.text) + "\n    ")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }